// Based on 'mui-icons-material/lib/Hexagon'

export const svgPathData = 'M17.2 3H6.8l-5.2 9 5.2 9h10.4l5.2-9z';
export const svgPath = `path://${svgPathData}`;
